<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <select 
      v-show="C_isVisible"
      :disabled="isTrue(P_disabled) || P_editing" 
      :style="C_listStyle" 
      v-model="DV_value"
      class="G_select"
    >
      <option v-for="option in C_dropdownOptions" :key="option">
        {{option}}
      </option>
    </select>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    "P_commaSeparatedOptions",
    "P_label",
    "P_value",
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  data () {
    return {
      // we can get this from prop
      DV_label: this.P_label || "Please choose",
      DV_value: this.P_value || "",
      DV_commaSeparatedOptions: this.P_commaSeparatedOptions || ""
    }
  },
  computed: {
    C_dropdownOptions () {
      return this.DV_commaSeparatedOptions.split(' ').join('').split(',')
    },
    C_listStyle () {
      return {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }
    }
  },
  watch: {
    P_value() {
      this.DV_value = this.P_value || ""
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Grid/GList.vue